module.exports = __webpack_public_path__ + "img/nrs.49239d97.png";